import React from 'react';

import CarouselPage from '../../components/carousel';
import Directory from '../../components/directory'


const Homepage = () => {
    return (
        <div className="homepage">


            <CarouselPage />
            <Directory />

        </div>
    )
}

export default Homepage;